<template>
  <div>
    <b-card no-body class="mb-4 availtable datatable wizardcontent " >
      <b-tabs v-model="tabIndex" pills card>
        <b-tab>
          <template #title :title-link-class="linkClass(0)">
            <span id="step1">
              <div class="inline countcircle text-primary">1.</div>
              Data Source<i
                :class="
                  section_1_valid
                    ? 'fa fa-check-circle ml-1'
                    : 'fa fa-times-circle text-danger ml-1'
                "
              ></i>
            </span>
          </template>
          <b-tooltip target="step1" triggers="hover"
            >Step 1. Still has mandatory data missing from the form.</b-tooltip
          >
          <b-card-body class="p-3 ">
            <b-card-text >
              <div>
                <p>Select the source from which to copy data.</p>
                <b-row>
                  <b-col cols="3"
                    >
                    <!-- <b-list-group>
                      <b-list-group-item
                        ><i class="fa fa-file"></i> General</b-list-group-item
                      >
                      <b-list-group-item
                        ><i class="fa fa-file"></i> Columns</b-list-group-item
                      >
                      <b-list-group-item
                        ><i class="fa fa-file"></i> Advanced</b-list-group-item
                      >
                      <b-list-group-item
                        ><i class="fa fa-file"></i> Preview</b-list-group-item
                      >
                    </b-list-group> -->
                    </b-col
                  >
                  <b-col>
                    <b-row>
                      <b-col
                        >Select a file and specify the file properties and the
                        file format.</b-col
                      >
                    </b-row>
                    <b-row class="mt-2">
                      <b-col>
                        <b-form-group
                          label="File Name"
                          label-for="filename"
                          label-cols="12"
                        >
                          <b-input-group>
                            <b-form-input
                              type="text"
                              v-model="item.filename"
                              placeholder="Enter file name"
                              size="sm"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button
                                size="sm"
                                variant="outline-primary"
                                @click="item.filename = ''"
                              >
                                <i class="fa fa-search pr-2"></i>Browse
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group
                          label="Locale"
                          label-for="locale"
                          label-cols="12"
                          label-size="sm"
                        >
                          <treeselect
                            instanceId="locale"
                            type="text"
                            v-model="item.locale"
                            :clearable="false"
                            :options="[
                              {
                                label: 'English (United Kingdom)',
                                id: 'English (United Kingdom)',
                              },
                            ]"
                          ></treeselect>
                        </b-form-group>
                      </b-col>
                      <b-col cols="2">
                        <b-form-group
                          label="Unicode"
                          label-for="unicode"
                          label-cols="12"
                        >
                          <b-form-checkbox
                            id="unicode"
                            v-model="item.unicode"
                            class="z-0"
                          >
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group
                          label="Code Page"
                          label-for="codepage"
                          label-cols="12"
                          label-size="sm"
                        >
                          <treeselect
                            instanceId="codepage"
                            type="text"
                            v-model="item.codepage"
                            :clearable="false"
                            :options="[
                              {
                                label: '65001 (UTF-8)',
                                id: '65001 (UTF-8)',
                              },
                            ]"
                          ></treeselect>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group
                          label="Format"
                          label-for="format"
                          label-cols="12"
                          label-size="sm"
                        >
                          <treeselect
                            instanceId="format"
                            type="text"
                            v-model="item.format"
                            :clearable="false"
                            :options="[
                              {
                                label: 'Delimited',
                                id: 'Delimited',
                              },
                            ]"
                          ></treeselect>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col>
                        <b-form-group
                          label="Text qualifier"
                          label-for="textqualifier"
                          label-cols="12"
                        >
                          <b-input-group>
                            <b-form-input
                              type="text"
                              v-model="item.textqualifier"
                              placeholder="<none>"
                              size="sm"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group
                          label="Header Row Delimiter"
                          label-for="headerdelimiter"
                          label-cols="12"
                          label-size="sm"
                        >
                          <treeselect
                            instanceId="headerdelimiter"
                            type="text"
                            v-model="item.headerdelimiter"
                            :clearable="false"
                            :options="[
                              {
                                label: '{CR}{LF}',
                                id: '{CR}{LF}',
                              },
                            ]"
                          ></treeselect>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col>
                        <b-form-group
                          label="Header rows to skip"
                          label-for="headerrowstoskip"
                          label-cols="12"
                        >
                          <b-input-group>
                            <b-form-input
                              type="number"
                              v-model="item.headerrowstoskip"
                              placeholder="0"
                              size="sm"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-input-group>
                          <b-form-checkbox
                            id="columnnames"
                            v-model="item.columnnames"
                            class="z-0"
                          >
                          </b-form-checkbox>
                          <span>Column names in the first data row</span>
                        </b-input-group></b-col
                      >
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </b-card-text>
          </b-card-body>
        </b-tab>
        <b-tab>
          <template #title :title-link-class="linkClass(1)">
            <div class="inline countcircle text-primary">2.</div>
            Columns<i
              :class="
                section_2_valid
                  ? 'fa fa-check-circle ml-1'
                  : 'fa fa-times-circle text-danger ml-1'
              "
            ></i>
          </template>
          <b-card-body class="p-3">
            <b-card-text>
              <div>
                <p>Select the source from which to copy data.</p>
                <b-row>
                  <b-col cols="3"
                    >
                    <!-- <b-list-group>
                      <b-list-group-item
                        ><i class="fa fa-file"></i> General</b-list-group-item
                      >
                      <b-list-group-item
                        ><i class="fa fa-file"></i> Columns</b-list-group-item
                      >
                      <b-list-group-item
                        ><i class="fa fa-file"></i> Advanced</b-list-group-item
                      >
                      <b-list-group-item
                        ><i class="fa fa-file"></i> Preview</b-list-group-item
                      >
                    </b-list-group> -->
                    </b-col
                  >
                  <b-col>
                    <b-row>
                      <b-col
                        >Specify the characters that delimit the source
                        file.</b-col
                      >
                    </b-row>
                    <b-row class="mt-2">
                      <b-col>
                        <b-form-group
                          label="Row Delimiter"
                          label-for="rowdelimiter"
                          label-cols="12"
                          label-size="sm"
                        >
                          <treeselect
                            instanceId="rowdelimiter"
                            type="text"
                            v-model="item.rowdelimiter"
                            :clearable="false"
                            :options="[
                              {
                                label: '{CR}{LF}',
                                id: '{CR}{LF}',
                              },
                            ]"
                          ></treeselect>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col>
                        <b-form-group
                          label="Column Delimiter"
                          label-for="columndelimiter"
                          label-cols="12"
                          label-size="sm"
                        >
                          <treeselect
                            instanceId="columndelimiter"
                            type="text"
                            v-model="item.columndelimiter"
                            :clearable="false"
                            :options="[
                              {
                                label: 'Comma {,}',
                                id: 'Comma {,}',
                              },
                            ]"
                          ></treeselect>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-table
                          striped
                          hover
                          :items="items"
                          :fields="fields"
                          :dark="$store.state.darkMode"
                          ref="btable"
                          small
                          caption-bottom
                          show-empty
                        ></b-table>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </b-card-text>
          </b-card-body>
        </b-tab>
      </b-tabs>
      <div class="text-center">
        <i
          v-if="tabIndex != 0"
          class="fa fa-chevron-circle-left fa-2x text-primary pointer"
          @click="tabIndex--"
          title="Prev"
        ></i>
        <i
          v-if="tabIndex != 3"
          class="fa fa-chevron-circle-right fa-2x text-primary ml-2 pointer"
          @click="tabIndex++"
          title="Next"
        ></i>
      </div>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>

          <b-col class="text-right" cols="12">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button
              squared
              size="sm"
              variant="primary"
              @click="save()"
              v-if="
                item.status == 'unsubmitted'
                  ? true
                  : false || user.permissions.includes('draftinvoices.save')
              "
            >
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
  name: "Import",
  data() {
    return {
      item: {
        filename: null,
        locale: "English (United Kingdom)",
        unicode: false,
        codepage: "65001 (UTF-8)",
        format: "Delimited",
        textqualifier: null,
        headerdelimiter: "{CR}{LF}",
        headerrowstoskip: "0",
        columnnames: true,
        rowdelimiter: "{CR}{LF}",
        columndelimiter: "Comma {,}",
      },
      fields: [
        {
          key: "blac",
          label: "BL A/C",
          sortable: true,
          class: "text-center",
        },
        {
          key: "blentry",
          label: "BL Entry",
          sortable: true,
          class: "text-center",
        },
        {
          key: "bllineno",
          label: "BL Line No",
          sortable: true,
          class: "text-center",
        },
        {
          key: "blconjline",
          label: "BL Conj line",
          sortable: true,
          class: "text-center",
        },
      ],
      items: [
        { blac: "BCARDCONF", blentry: 1064431, bllineno: 1, blconjline: 0 },
        { blac: "BCARDCONF", blentry: 1064432, bllineno: 1, blconjline: 0 },
        { blac: "BCARDCONF", blentry: 1064433, bllineno: 1, blconjline: 0 },
      ],
    };
  },


};
</script>

<style>
</style>